import { camelCase as _camelCase, get as _get } from "lodash-es";

const loadingDefaultStatus = { loading: false, error: false };

export const createLoadingState = (selectors) => (state) => {
  const loadingState = {};

  for (let selector of selectors) {
    let selectorState = _get(state.loading, selector, loadingDefaultStatus);

    loadingState[_camelCase(`loading ${selector}`)] = selectorState.loading;
    loadingState[_camelCase(`error ${selector}`)] = selectorState.error;
  }

  return loadingState;
};
